module.exports = __webpack_public_path__ + "img/Balkon09.602b1bf1.jpg";